var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2102_103333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.560059 19C0.560059 15.3529 1.64155 11.7877 3.66776 8.75529C5.69397 5.72285 8.57391 3.35935 11.9434 1.96367C15.3128 0.567987 19.0205 0.202814 22.5975 0.914325C26.1745 1.62584 29.4602 3.38208 32.0391 5.96096C34.618 8.53984 36.3742 11.8255 37.0857 15.4025C37.7973 18.9795 37.4321 22.6872 36.0364 26.0567C34.6407 29.4262 32.2772 32.3061 29.2448 34.3323C26.2123 36.3585 22.6471 37.44 19.0001 37.44C14.1112 37.4344 9.42411 35.4899 5.96715 32.0329C2.51018 28.5759 0.565617 23.8889 0.560059 19Z",
    fill: "#E02020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 27.985C23.9622 27.985 27.9849 23.9623 27.9849 19C27.9849 14.0377 23.9622 10.015 18.9999 10.015C14.0376 10.015 10.0149 14.0377 10.0149 19C10.0149 23.9623 14.0376 27.985 18.9999 27.985Z",
    stroke: "#E5E5E5",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1309 12.433L12.6589 25.365",
    stroke: "#E5E5E5",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2102_103333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.ad0446a7d3e8fbb80a2304b20526bac9.svg";
export { ForwardRef as ReactComponent };